/* カートページで商品数量が変更された時、金額表示変更用の関数を呼び出し */
function clickChangeQuantity() {
  if(typeof checkTotalPrice == 'function') {
    setTimeout(checkTotalPrice, 1000); 
  }
  if(typeof dispFreeShippingPrice == 'function') {
    setTimeout(dispFreeShippingPrice, 1000); 
  }
}